<!-- 详细测评报告 -->
<template>
  <div class="container HomeDetail">
    <!-- 趣味测评报告 -->
    <FunReportDetail v-if="type == 1"></FunReportDetail>
    <!-- 专业测评报告 -->
    <ProfessionalReportDetail v-if="type == 2"></ProfessionalReportDetail>
    <TreeReportDetail v-if="type == 3"></TreeReportDetail>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import FunReportDetail from "./components/funReportDetail.vue";
import ProfessionalReportDetail from "./components/professionalReportDetail.vue";
import TreeReportDetail from "./components/treeReportDetail.vue";
import { setToken } from "@/utils/auth";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { FunReportDetail, ProfessionalReportDetail, TreeReportDetail },
  data() {
    // 这里存放数据
    return {
      type: 0, // 1：趣味测评 2：专业测评
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // toDetail() {
    //   this.$router.push({
    //     path: "/home/detail",
    //     query: {
    //       id: this.$route.query.id,
    //     },
    //   });
    // },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.type = this.$route.query.type;
    console.log(this.type);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variable.scss";
$ListHeight: calc(100vh - 120px);
.container {
  color: #333333;
  // height: $ListHeight;
  // height: 100vh;
  // background-color: #fff;
}
.HomeDetail {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.navigator {
  width: 100vw;
  height: 85px;
  background-color: #333;
  color: #fff;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  .nav_title {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    z-index: 1;
  }
  .back {
    position: absolute;
    left: 0;
    z-index: 99;
    padding: 20px;
    img {
      height: 45px;
      font-size: 32px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 45px;
    }
    span:last-child {
      margin-left: 20px;
    }
  }
}
</style>
